
import { defineComponent } from "vue";
import CategoryCard from "@/modules/market/components/CategoryCard.vue";

export default defineComponent({
  components: {
    CategoryCard,
  },
  setup() {
    const categories = ["Art", "Collectibles", "Domains", "Music"].map((c) => ({
      name: c,
      image: require(`@/assets/images/category-${c.toLowerCase()}.webp`),
    }));

    return { categories };
  },
});
